import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid, TextField,
  Typography
} from '@mui/material';
import { useSelector } from 'react-redux';
import { AccountCircle } from '@mui/icons-material';
import { SECURITY_ROLES } from '../../../../../constants/SECURITY_ROLES';
import { ErrorMessage } from 'formik';
import { states as States } from '../../../../../constants/states';

const useStyles = makeStyles(theme => ({
  root: {
    actions: {
      justifyContent: 'flex-end'
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    minHeight: '100%',
    padding: 0,
  },
  titleHeader: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.white
  },
  title: {
    fontSize: "large"
  },
  subheader: {
    color: theme.palette.white
  },
  button: {
    color: theme.palette.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light

    }
  },
  icon: {
    height: 32,
    width: 32,
    color: theme.palette.primary.main
  },
  action: {
    margin: 0
  }
}));

const About = props => {
  const { user, className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={classes.root}
      // className={classes.content}
    >
      <form>
        <CardHeader
          className={classes.titleHeader}
          classes={{
            action: classes.action,
            subheader: classes.subheader,
            title: classes.title
          }}
          subheader=""
          title="About License"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
            >
              <TextField
                fullWidth
                label="Level"
                margin="dense"
                name="level"
                value={user.licenseLevel}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <TextField
                fullWidth
                label="Expiry Date"
                margin="dense"
                name="expirydate"
                value={user.licenseExpireDate}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
      </form>
    </Card>
  );
};

About.propTypes = {
  className: PropTypes.string
};

export default About;
